import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

import isStaticElement from 'editor/src/util/design/isStaticElement';

import { removeMediaElement } from './removeMediaElementReducer';

const clearImageElementsByImageIdReducer = (state: DesignState, action: PayloadAction<string>) => {
  const imageId = action.payload;
  const { designData } = state;
  if (!designData) {
    return;
  }

  designData.spreads.forEach((spread, spreadIndex) => {
    spread.pages.forEach((page, pageIndex) => {
      const { media } = page.groups;
      if (!media) {
        return;
      }

      // backwards, so removing an element keeps the indexes still to visit
      let i = media.length;
      while (i > 0) {
        i -= 1;
        const element = media[i];
        if (element.type !== 'image' || element.imageId !== imageId) {
          continue;
        }

        // An empty static frame is a placeholder nobody can fill, so the element goes with its image.
        if (isStaticElement(element)) {
          removeMediaElement(designData, spreadIndex, pageIndex, i);
        } else {
          element.imageId = '';
        }
      }
    });
  });
};

export default clearImageElementsByImageIdReducer;
